import { useCallback, useMemo, useState } from 'react';
import MassActionsContext from './context';
import { MassActionsContextOrder } from './type';

const MassActionsProvider: React.FC = ({ children }) => {
    const [orders, setOrders] = useState<MassActionsContextOrder[]>([]);
    const toggle = useCallback((type: string, id: string) => {
        setOrders((_orders) =>
            _orders.find(i => i.id == id) ? _orders.filter((i) => i.id !== id) : [..._orders, { id, type }],
        );
    }, []);
    const ids = useMemo(() => orders.map(item => item.id), [orders]);
    const allowedType = useMemo(() => orders.length > 0 ? orders[0].type : null, [orders]);
    const show = useMemo(() => orders.length > 0, [orders]);
    const linkIds = useMemo(() => ids.join('_'), [ids]);
    const value = useMemo(
        () => ({
            ids,
            linkIds,
            show,
            allowedType,
            toggle,
        }),
        [ids, linkIds, show, toggle],
    );
    return (
        <MassActionsContext.Provider value={value}>
            {children}
        </MassActionsContext.Provider>
    );
};

export default MassActionsProvider;
